export default {
  "content": "<path d=\"M5 8H3v10h18V8h-2V6h3a1 1 0 011 1v12a1 1 0 01-1 1H2a1 1 0 01-1-1V7a1 1 0 011-1h3v2z\" fill=\"#7B61FF\"/><path d=\"M11.37 3.725a1 1 0 011.337.068l4.5 4.5-1.414 1.414L13 6.914V16h-2V6.914L8.207 9.707 6.793 8.293l4.5-4.5.076-.068z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};